import script from "./trade.vue?vue&type=script&setup=true&lang=ts"
export * from "./trade.vue?vue&type=script&setup=true&lang=ts"

import "./trade.vue?vue&type=style&index=0&id=38b4611b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b4611b"]])

export default __exports__